export default __webpack_public_path__ + "static/springandsummer (9)-0dec4f898ad4c0a7b0e882ebf9e43605.jpeg";